import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const addField = createAction(constants.addIncidentReportField);
export const setUserType = createAction(constants.setIncidentReportFieldsUserType);
export const updateBuilderFields = createAction(constants.updateIncidentReportBuilderFields);

export const incidentReportFieldsRequest = createRequest(constants.incidentReportFields);
export const incidentReportFieldsSuccess = createSuccess(constants.incidentReportFields);
export const incidentReportFieldsFailure = createFailure(constants.incidentReportFields);

export const updateIncidentReportFieldsRequest = createRequest(constants.updateIncidentReportFields);
export const updateIncidentReportFieldsSuccess = createSuccess(constants.updateIncidentReportFields);
export const updateIncidentReportFieldsFailure = createFailure(constants.updateIncidentReportFields);

export const deleteIncidentReportFieldRequest = createRequest(constants.deleteIncidentReportField);
export const deleteIncidentReportFieldSuccess = createSuccess(constants.deleteIncidentReportField);
export const deleteIncidentReportFieldFailure = createFailure(constants.deleteIncidentReportField);

export const incidentReportFieldResultsRequest = createRequest(constants.incidentReportFieldResults);
export const incidentReportFieldResultsSuccess = createSuccess(constants.incidentReportFieldResults);
export const incidentReportFieldResultsFailure = createFailure(constants.incidentReportFieldResults);

export const requestIncidentReportFields = incidentReportFieldsRequest;
export const updateIncidentReportFields = updateIncidentReportFieldsRequest;
export const deleteIncidentReportField = deleteIncidentReportFieldRequest;
export const requestIncidentReportFieldResults = incidentReportFieldResultsRequest;
